import { useMemo } from "react";
import { useSelector } from "react-redux";
import { useHotelList, useHotelsAvailabilityFilters } from "@tenant/hotels";
import { HotelsAvailabilitySelectors } from "../store";

export const useHotelsAvailability = () => {
  const { context: filtersContext, handlers: filtersHandlers } =
    useHotelsAvailabilityFilters();

  const { context: hotelListContext } = useHotelList();

  const hotels = useSelector(HotelsAvailabilitySelectors.getHotels);

  const isAvailabilityPageLoading = useSelector(
    HotelsAvailabilitySelectors.isAvailabilityPageLoading
  );

  const nextPageToken = useSelector(
    HotelsAvailabilitySelectors.getNextPageToken
  );

  const isLoading =
    isAvailabilityPageLoading || (hotels.length === 0 && nextPageToken != null);

  const rooms = useSelector(
    HotelsAvailabilitySelectors.getSearchFormRoomsCount
  );

  const isLoadingNext = useSelector(HotelsAvailabilitySelectors.isLoadingNext);
  const isError = useSelector(HotelsAvailabilitySelectors.hasError);

  const context = useMemo(
    () => ({
      ...filtersContext,
      ...hotelListContext,
      rooms,
      isLoading,
      isLoadingNext,
      isError,
    }),
    [filtersContext, hotelListContext, isError, isLoading, isLoadingNext, rooms]
  );

  return {
    context,
    handlers: filtersHandlers,
  };
};
